<template>
    <div class="animated fadeIn custom-cases bgV2 safetyApp">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    :data="tabData">
                    <template slot="gofixTab:all">
                        <safety-inspection></safety-inspection>
                    </template>
                    <template slot="gofixTab:completed">
                        <safety-inspection status="Completed"></safety-inspection>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SafetyInspection from './safety-inspection.vue'
export default {
    name: 'SafetyInspectionTab',
    components: {
        SafetyInspection
    },
    data() {
        return {
            tabData:[
                {
                    key: "all",
                    title: "All",
                    active: true
                },
                {
                    key: "completed",
                    title: "Completed",
                    active: false
                },
            ],
        }
    },
}
</script>